"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionCounts = void 0;
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const ui_1 = require("client/components/ui");
const transaction_counts_header_1 = require("client/modules/reporting/modules/reporting-list/components/report-container/transaction-counts-report/components/transaction-counts-header");
const store_1 = require("client/modules/reporting/store");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const no_data_found_1 = require("../no-data-found/no-data-found");
require("./transaction-counts-report.less");
let TransactionCounts = class TransactionCounts extends React.Component {
    constructor(props) {
        super(props);
        this.onButtonExport = () => {
            const params = {
                fileName: "Transaction_Counts.csv"
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        this.storeData = {
            defaultColDef: {
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                sortable: true,
                resizable: true,
                filter: true,
                comparator(a, b) {
                    if (typeof a === "string") {
                        return a.localeCompare(b);
                    }
                    else {
                        return a > b ? 1 : a < b ? -1 : 0;
                    }
                }
            },
            columnDefs: [
                // E-103 start
                {
                    headerName: "Start Date",
                    field: "startDate",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "End Date",
                    field: "endDate",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                // E-103 end
                {
                    headerName: "E1/CardFinder Requests",
                    field: "e1",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "B1 Requests",
                    field: "b1",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "B2 Requests",
                    field: "b2",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "eRx Connect",
                    field: "erxConnect",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "SureScripts Pass Through",
                    field: "SureScriptsPassThrough",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                }
            ],
            rowSelection: "single",
            rowData: [],
            multiSortKey: "ctrl",
            floatingFilter: true
        };
    }
    async componentDidMount() {
        await store_1.reportsStore.loadTransactionCounts();
    }
    componentWillUnmount() {
        store_1.reportsStore.transactionCountsData = null;
    }
    render() {
        const storeData = store_1.reportsStore.transactionCountsData;
        this.storeData.rowData = storeData;
        const loadingData = store_1.reportsStore.showLoader;
        if (storeData && storeData.length > 0) {
            return (React.createElement(React.Fragment, null,
                React.createElement(transaction_counts_header_1.TransactionCountsHeader, { title: "Transaction Counts Analytics", withDatePicker: true }),
                React.createElement("div", { className: "ag-theme-balham", style: {
                        height: "85%",
                        width: "100%"
                    } },
                    React.createElement("button", { onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
                    React.createElement(ag_grid_react_1.AgGridReact, { onGridReady: params => (this.storeData.gridApi = params.api), rowSelection: this.storeData.rowSelection, columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, frameworkComponents: this.storeData.frameworkComponents, multiSortKey: this.storeData.multiSortKey, animateRows: true, sideBar: true, groupMultiAutoColumn: true, floatingFilter: this.storeData.floatingFilter, suppressExcelExport: true, rowData: this.storeData.rowData }))));
        }
        if (storeData) {
            if (loadingData) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(transaction_counts_header_1.TransactionCountsHeader, { title: "Transaction Counts Analytics", withDatePicker: true }),
                    React.createElement("div", null, "Loading Data...")));
            }
            // Return a Custom built component here to handle 0 data returned.
            return (React.createElement(no_data_found_1.default, { headerComponent: React.createElement(transaction_counts_header_1.TransactionCountsHeader, { title: "Transaction Counts Analytics", withDatePicker: true }) }));
        }
        return React.createElement(ui_1.UiLoadingIndicator, null);
    }
};
TransactionCounts = __decorate([
    mobx_react_1.observer
], TransactionCounts);
exports.TransactionCounts = TransactionCounts;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/transaction-counts-report/transaction-counts-report.tsx
// module id = 3943
// module chunks = 0